/* @flow */

import * as React from 'react';
import classNames from 'classnames';

import useSheet from '../../jss';

type Props = {
  children?: React$Element<*>,
  className?: string,
  disabled?: boolean,
  sheet: Object,
  scheme?: 'light' | 'dark'
};

const defaultProps = {
  children: undefined,
  className: undefined,
  disabled: false,
  scheme: 'light'
};

function FilterLabel({ children, className, disabled, scheme, sheet: { classes } }: Props) {
  return (
    <div className={classNames(classes.label, className, { disabled }, scheme)}>{children}</div>
  );
}

FilterLabel.defaultProps = defaultProps;

function applyStyles(theme: Theme) {
  return {
    label: {
      '&.light': {
        color: theme.color.basis3
      },
      '&.dark': {
        color: theme.color.basis4
      },
      textTransform: 'uppercase',
      '&.disabled': {
        opacity: 0.5
      }
    }
  };
}

export default useSheet(applyStyles)(FilterLabel);
